import TrendPopupContentTrendGrid from '@/components/Crash/TrendPopup/Content/TrendGrid';
import { TrendTutorialExampleProps } from './props';
import styles from './styles.module.scss';
import useTranslation from 'next-translate/useTranslation';
import { trenballColors } from '@/constants/trenball-colors';
import { Fragment } from 'react';

export default function TrendTutorialExample({
  data,
  multipliers,
}: TrendTutorialExampleProps) {
  const { t } = useTranslation('smash-racing');

  return (
    <div className={styles.container}>
      <TrendPopupContentTrendGrid data={data} />

      <div className={styles.container__card}>
        <span className={styles.container__card__label}>
          {t('trend_explanation')}
        </span>

        <div className={styles.container__card__row}>
          {multipliers.map((multiplier, i) => (
            <Fragment key={`trend-multiplier_${i}`}>
              <span
                className={styles.container__card__label}
                style={{
                  color: trenballColors.get(multiplier.color),
                }}
              >
                {multiplier.value}
              </span>

              {i !== multipliers.length - 1 && (
                <i
                  className={`${styles.container__card__icon} fa-solid fa-arrow-right`}
                />
              )}
            </Fragment>
          ))}
        </div>
      </div>
    </div>
  );
}
